export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
  /** Where the quote comes from, shown as a pill (voice-of-customer cards). */
  source?: string
}

/**
 * Public comments by dance teachers about how they plan (from the DPS 40 product research).
 * They are NOT reviews of this pack. Swap in real buyer reviews (with permission) as they arrive.
 */
export const askedFor: Testimonial[] = [
  {
    quote: 'I write down all my dance steps!',
    author: 'Nina Kay, dance instructor',
    role: 'On how she keeps track of her routines',
    source: 'zindacademy.com',
  },
  {
    quote: '…my own secret language.',
    author: 'Nina Kay, dance instructor',
    role: 'On the mix of symbols, letters and numbers she uses to write routines',
    source: 'zindacademy.com',
  },
]

export const tiredOf: Testimonial[] = [
  {
    quote: 'As dancers we feel like we need to keep doing more and more.',
    author: 'Jenna Eberhardt, studio director',
    role: 'On the pressure to keep producing material',
    source: 'dance-teacher.com',
  },
  {
    quote: '…so that dancers aren’t feeling stuck in any one style.',
    author: 'Blake Piatczyc, studio director',
    role: 'On varying styles for students',
    source: 'dance-teacher.com',
  },
]
